// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CalmLogoGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 103 41"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.527 9.69a30.584 30.584 0 0 0-3.936 6.42C1.529 18.454.729 20.97.305 23.583c-2.031 14.342 6.683 16.623 8.17 16.902 7.638.892 13.263-3.272 15.922-5.826.959 4.787 5.738 4.845 7.833 2.683.535-.551.962-1.229 1.296-1.934 1.242 4.524 5.222 2.983 5.69 2.783 2.22-.833 4.54-3.927 6.18-6.522 1.042 3.558 3.054 7.372 6.92 6.963 2.329-.056 8.169-6.273 8.709-5.462.54.671.682 1.903.647 3.742-.035 1.839 1.422 1.931 2.083 1.748 1.02-.282 1.662-2.296 2.73-4.047.838-1.372 1.462-2.15 2.292-3.063.42-.452 2.316-2.417 3.653-1.75 1.337.668 1.474 2.039 1.566 2.797.103.76.104 1.567.136 2.45-.039 3.045 1.39 3.475 1.793 3.587 3.305.894 3.51-5.329 5.934-7.639.227-.235 2.345-2.425 3.555 1.148 1.747 6.459 7.124 8.873 14.362 5.282 1.343-.666 1.607-.927 2.34-1.473a.709.709 0 0 0 .284-.562v-.01a.704.704 0 0 0-1.047-.613l-.003.003c-.741.411-3.206 1.235-3.985 1.516-2.921.478-6.499.37-8.26-3.904-.532-1.287-1.058-2.447-1.966-3.666-1.026-1.379-4.388-3.018-7.526-.06-.816.748-1.418 1.576-1.94 2.401-.213.338-.41.677-.595 1.017l-.037-.135c-.277-.957-1.164-4.495-4.854-5.07-.507-.042-2.56-.273-5.401 2.848-.993 1.082-1.819 2.234-2.589 3.4l-.002.004c-.136-.634-.3-1.21-.463-1.463-2.413-3.72-6.069-.75-7.643.358-3.528 2.485-5.164 5.824-7.314-1.762a31.755 31.755 0 0 1-.668-3.26c2.143-3.647 6.506-14.743 4.002-22.182-.163-.47-1.035-2.872-3.131-2.717-.301.03-2.689-.221-3.994 6.461-1.221 6.46-.951 14.787-.655 17.548.033.286.096.851.207 1.59-2.066 3.54-4.778 7.566-6.431 7.753-2.148.244-1.55-1.738-2.86-6.143-.226-.57-.95-3.293-4.209-3.158-1.593.066-3.28.482-5.585 3.006-3.74 4.098-12.272 10.262-18.374 6.388-.663-.515-3.96-3.214-2.745-11.303a26.107 26.107 0 0 1 1.957-6.452 28.527 28.527 0 0 1 3.352-5.652C15.909 4.42 21.339 3.52 22.41 3.566c2.747.001 3.46 3.563 3.459 3.53.06.626.616 1.084 1.241 1.023a1.138 1.138 0 0 0 1.02-1.243c-.004-.031.006-1.165-.464-2.24-.43-1.402-1.67-2.704-2.39-3.185-.89-.62-2.068-.95-3.456-.951-3.987 0-9.708 2.733-15.294 9.19M47.6 20.944c-.029-12.559 1.565-15.41 1.682-15.19.608 1.128 1.918 8.2-1.656 15.93-.01-.247-.018-.493-.026-.74m-20.676 12.34c.047-3.323 4.179-5.412 5.288-3.1.091.19.152.403.211.614-.192.611-.27 1.597-.919 2.935-.685 1.413-1.762 2.114-2.7 2.114-1.037 0-1.903-.859-1.88-2.563"
			fill="url(#CalmLogoGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="CalmLogoGradient_tsx__a"
				x1={0}
				y1={0.5}
				x2={0}
				y2={40.608}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#60B4E7" />
				<stop offset={1} stopColor="#6461E0" />
			</linearGradient>
		</defs>
	</svg>
);
export default CalmLogoGradient;
